import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import DataTable from 'react-data-table-component';
import { useLocation } from 'react-router-dom';

import axios from 'axios';
import { BigNumber, ethers, utils } from 'ethers';

import { useGlobalContext } from '../../AppContext';
import {
  RemindersEnsTableDataProps,
  RemindersTokenTableDataProps,
  RemindersWhaleTableDataProps,
} from '../../constants/interfaces';
import contractArtifacts from '../../sdk/test/ens.json';
import { BigButton } from '../../components/BigButton';
import { BigMenu } from '../../components/BigMenu';
import { Button } from '../../components/Button';
import { ConfirmAlert } from '../../components/ConfirmAlert';

import './Reminders.scss';

export const Reminders = () => {
  const { config, isMobile } = useGlobalContext();
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  // use state
  const [selectedType, setSelectedType] = useState<string>('ens');
  const [showTable, setShowTable] = useState<JSX.Element>(<></>);
  const [tableDataEns, setTableDataEns] = useState<RemindersEnsTableDataProps[]>([]);
  const [tableDataToken, setTableDataToken] = useState<RemindersTokenTableDataProps[]>([]);
  const [tableDataWhale, setTableDataWhale] = useState<RemindersWhaleTableDataProps[]>([]);
  const [rawData, setRawData] = useState<any>(false);

  const [newEns, setNewEns] = useState<string>('');
  const [validNewEns, setValidNewEns] = useState<boolean>(false);
  const [showAddNewEns, setShowAddNewEns] = useState<boolean>(false);
  const [showAddNewEnsError, setShowAddNewEnsError] = useState<string>('');

  const [newToken, setNewToken] = useState<string>('');
  const [validNewToken, setValidNewToken] = useState<boolean>(false);
  const [showAddNewToken, setShowAddNewToken] = useState<boolean>(false);
  const [showAddNewTokenError, setShowAddNewTokenError] = useState<string>('');

  const [newWhale, setNewWhale] = useState<string>('');
  const [validNewWhale, setValidNewWhale] = useState<boolean>(false);
  const [showAddNewWhale, setShowAddNewWhale] = useState<boolean>(false);
  const [showAddNewWhaleError, setShowAddNewWhaleError] = useState<string>('');

  const location = useLocation();

  // use effect
  useEffect(() => {
    if (location && location.state) {
      const myState: any = location ? location.state : { type: '' };
      if (myState.type) {
        console.log(myState.type);
        setSelectedType(myState.type);
      }
    }
    //setSelectedType(value);
  }, [location]);

  const getExpiryDate = async (address: string): Promise<BigNumber> => {
    const contract = await getContract();
    return await contract.nameExpires(address);
  };

  async function getContract(): Promise<ethers.Contract> {
    const provider = new ethers.providers.JsonRpcProvider('https://cloudflare-eth.com');
    return new ethers.Contract(
      '0x57f1887a8BF19b14fC0dF6Fd9B2acc9Af147eA85',
      contractArtifacts,
      provider,
    );
  }

  function timeConverter(UNIX_timestamp: number) {
    const a = new Date(UNIX_timestamp * 1000);
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const year = a.getFullYear();
    const month = months[a.getMonth()];
    const date = a.getDate();
    const hour = a.getHours();
    const min = a.getMinutes();
    const sec = a.getSeconds();
    const time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
    return time;
  }

  // const variables
  const ensColumns = [
    {
      name: 'Domain',
      selector: (row: RemindersEnsTableDataProps) => row.domain,
      sortable: true,
      width: '300px',
    },
    {
      name: 'Expiry',
      selector: (row: RemindersEnsTableDataProps) => timeConverter(Number(row.expiry_date)),
      sortable: true,
    },
    {
      name: 'Reminder',
      selector: () => 'When expiry date close',
      sortable: false,
    },
    {
      name: '',
      selector: (row: RemindersEnsTableDataProps) => row.button,
      cell: (row: RemindersEnsTableDataProps) => {
        return (
          <div className="table-actions">
            <img
              onClick={() =>
                confirmAlert({
                  closeOnClickOutside: false,
                  customUI: ({ onClose }) => {
                    return (
                      <ConfirmAlert title="Are you sure?" onClose={onClose}>
                        <div className="confirm-button-flex">
                          <BigButton type="light" size="small" onClick={onClose} name="No" />
                          <BigButton
                            type="dark"
                            size="small"
                            onClick={() => {
                              removeFromReminder(row.id);
                              onClose();
                            }}
                            name="Yes, Delete it!"
                          />
                        </div>
                      </ConfirmAlert>
                    );
                  },
                })
              }
              src="/icons/trash.svg"
              alt=""
            />
          </div>
        );
      },
    },
  ];

  const portfolioColumns = [
    {
      name: 'Token',
      selector: (row: RemindersTokenTableDataProps) => row.token,
      sortable: true,
      width: '300px',
    },
    {
      name: 'Price',
      selector: (row: RemindersTokenTableDataProps) => row.price,
      sortable: true,
    },
    {
      name: 'Reminder',
      sortable: false,
      cell: (row: RemindersTokenTableDataProps) => {
        console.log(row);
        return `${row.kind} - ${row.finalPrice}`;
      },
    },
    {
      name: '',
      selector: (row: RemindersTokenTableDataProps) => row.button,
      cell: (row: RemindersTokenTableDataProps) => {
        return (
          <div className="table-actions">
            <img
              onClick={() =>
                confirmAlert({
                  closeOnClickOutside: false,
                  customUI: ({ onClose }) => {
                    return (
                      <ConfirmAlert title="Are you sure?" onClose={onClose}>
                        <div className="confirm-button-flex">
                          <BigButton type="light" size="small" onClick={onClose} name="No" />
                          <BigButton
                            type="dark"
                            size="small"
                            onClick={() => {
                              removeFromReminder(row.id);
                              onClose();
                            }}
                            name="Yes, Delete it!"
                          />
                        </div>
                      </ConfirmAlert>
                    );
                  },
                })
              }
              src="/icons/trash.svg"
              alt=""
            />
          </div>
        );
      },
    },
  ];

  const whaleColumns = [
    {
      name: 'Contract',
      selector: (row: RemindersWhaleTableDataProps) => row.contract,
      sortable: true,
      width: '300px',
    },
    {
      name: 'Token',
      selector: (row: RemindersWhaleTableDataProps) => row.token,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Quantity',
      selector: (row: RemindersWhaleTableDataProps) => row.quantity,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Ratio (%)',
      selector: (row: RemindersWhaleTableDataProps) => row.ratio,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Reminder',
      selector: () => 'When the ratio is below 3%',
      sortable: false,
    },
    {
      name: '',
      selector: (row: RemindersWhaleTableDataProps) => row.button,
      cell: (row: RemindersWhaleTableDataProps) => {
        return (
          <div className="table-actions">
            <img
              onClick={() =>
                confirmAlert({
                  closeOnClickOutside: false,
                  customUI: ({ onClose }) => {
                    return (
                      <ConfirmAlert title="Are you sure?" onClose={onClose}>
                        <div className="confirm-button-flex">
                          <BigButton type="light" size="small" onClick={onClose} name="No" />
                          <BigButton
                            type="dark"
                            size="small"
                            onClick={() => {
                              removeFromReminder(row.id);
                              onClose();
                            }}
                            name="Yes, Delete it!"
                          />
                        </div>
                      </ConfirmAlert>
                    );
                  },
                })
              }
              src="/icons/trash.svg"
              alt=""
            />
          </div>
        );
      },
    },
  ];

  // functions

  // whale
  const removeFromReminder = async (id: number): Promise<void> => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/reminders.php`,
        params: {
          process: 'delete',
          id: id,
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (response && response.data && response.data.code === 0) {
        fetchRemindersList();
      }
    } catch (error) {}
  };

  const addToReminderEns = async (address: string): Promise<void> => {
    if (!validNewEns) {
      alert('you should enter a valid ens and name');
    } else {
      try {
        const expiryDate = await getExpiryDate(
          utils.keccak256(utils.toUtf8Bytes(address.split('.')[0])),
        );
        const response = await axios({
          url: `${process.env.REACT_APP_API}/reminders.php`,
          params: {
            process: 'add',
            type: 'ENS',
            domain: address,
            expiryDate: Number(expiryDate),
          },
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        });

        if (response && response.data && response.data.code === 0) {
          setShowAddNewEns(false);
          setValidNewEns(false);
          setShowAddNewEnsError('');
          fetchRemindersList();
        } else if (response && response.data && response.data.data) {
          setShowAddNewEnsError(response.data.data);
        }
      } catch (error) {}
    }
  };

  const addToReminderToken = async (address: string): Promise<void> => {
    if (!validNewToken) {
      alert('you should enter a valid ens and name');
    } else {
      try {
        const expiryDate = await getExpiryDate(
          utils.keccak256(utils.toUtf8Bytes(address.split('.')[0])),
        );
        const response = await axios({
          url: `${process.env.REACT_APP_API}/reminders.php`,
          params: {
            process: 'add',
            type: 'Portfolio',
            domain: address,
            expiryDate: Number(expiryDate),
          },
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        });

        if (response && response.data && response.data.code === 0) {
          setShowAddNewToken(false);
          setValidNewToken(false);
          setShowAddNewTokenError('');
          fetchRemindersList();
        } else if (response && response.data && response.data.data) {
          setShowAddNewTokenError(response.data.data);
        }
      } catch (error) {}
    }
  };

  const addToReminderWhale = async (address: string): Promise<void> => {
    if (!validNewWhale) {
      alert('you should enter a valid ens and name');
    } else {
      try {
        const expiryDate = await getExpiryDate(
          utils.keccak256(utils.toUtf8Bytes(address.split('.')[0])),
        );
        const response = await axios({
          url: `${process.env.REACT_APP_API}/reminders.php`,
          params: {
            process: 'add',
            type: 'Whales',
            domain: address,
            expiryDate: Number(expiryDate),
          },
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        });

        if (response && response.data && response.data.code === 0) {
          setShowAddNewWhale(false);
          setValidNewWhale(false);
          setShowAddNewWhaleError('');
          fetchRemindersList();
        } else if (response && response.data && response.data.data) {
          setShowAddNewWhaleError(response.data.data);
        }
      } catch (error) {}
    }
  };

  const fetchRemindersList = async (): Promise<void> => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API}/reminders.php`,
        params: {
          process: 'list',
        },
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      if (response && response.data && response.data) setRawData(response.data.data);
      else setRawData([]);
    } catch (error) {
      console.error(error);
    }
  };

  const renderShowTable = (data: any): void => {
    setShowTable(
      <DataTable
        noDataComponent={
          <div className="data-table-no-record">
            <h1>Alerts</h1>
            <hr />
            <div className="light-button-container">
              <div className="light-button">
                <Button
                  onClick={() => {
                    if (selectedType === 'ens') setShowAddNewEns(!showAddNewEns);
                    else if (selectedType === 'token') setShowAddNewToken(!showAddNewToken);
                    else if (selectedType === 'whale') setShowAddNewWhale(!showAddNewWhale);
                  }}
                  color="one"
                  size="large"
                  label={`Add New ${
                    selectedType === 'ens' ? 'ENS' : selectedType === 'token' ? 'Token' : 'Whale'
                  }`}
                />
              </div>
            </div>
          </div>
        }
        pagination
        columns={
          selectedType === 'ens'
            ? ensColumns
            : selectedType === 'token'
            ? portfolioColumns
            : whaleColumns
        }
        data={data}
      />,
    );
  };

  const handleOnChangeAddNewEns = (e: any) => {
    setNewEns(e.target.value);

    if (e.target.value) {
      setValidNewEns(true);
    } else {
      setValidNewEns(false);
    }
  };

  const addNewEns = () => {
    const onClose = () => {
      setShowAddNewEns(false);
      setValidNewEns(false);
    };
    return (
      <>
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <ConfirmAlert title="Add New ENS" onClose={onClose}>
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Enter ENS..."
                    onChange={e => handleOnChangeAddNewEns(e)}
                  />
                </div>
                {showAddNewEnsError && (
                  <div className="alert">
                    <img src="/icons/warning-solid.svg" />
                    {showAddNewEnsError}
                  </div>
                )}
                <div className="confirm-button-container">
                  <Button color="one" size="large" label="Cancel" onClick={onClose} />
                  <Button
                    color="three"
                    size="large"
                    disabled={!validNewEns}
                    onClick={() => {
                      addToReminderEns(newEns);
                    }}
                    label="Add to Reminders"
                  />
                </div>
              </ConfirmAlert>
            </div>
          </div>
        </div>
      </>
    );
  };

  const handleOnChangeAddNewToken = (e: any) => {
    setNewToken(e.target.value);

    if (e.target.value) {
      setValidNewToken(true);
    } else {
      setValidNewToken(false);
    }
  };

  const addNewToken = () => {
    const onClose = () => {
      setShowAddNewToken(false);
      setValidNewToken(false);
    };
    return (
      <>
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <ConfirmAlert title="Add New Token" onClose={onClose}>
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Enter contract address..."
                    onChange={e => handleOnChangeAddNewToken(e)}
                  />
                </div>
                <div className="search-input">
                  <input type="text" placeholder="Target price" />
                </div>
                <div className="search-input">
                  <select>
                    <option>Price down below</option>
                    <option>Price high above</option>
                  </select>
                </div>
                {showAddNewTokenError && (
                  <div className="alert">
                    <img src="/icons/warning-solid.svg" />
                    {showAddNewTokenError}
                  </div>
                )}
                <div className="confirm-button-container">
                  <Button color="one" size="large" label="Cancel" onClick={onClose} />
                  <Button
                    color="three"
                    size="large"
                    disabled={!validNewToken}
                    onClick={() => {
                      addToReminderToken(newToken);
                    }}
                    label="Add to Reminders"
                  />
                </div>
              </ConfirmAlert>
            </div>
          </div>
        </div>
      </>
    );
  };

  const handleOnChangeAddNewWhale = (e: any) => {
    setNewWhale(e.target.value);

    if (e.target.value) {
      setValidNewWhale(true);
    } else {
      setValidNewWhale(false);
    }
  };

  const addNewWhale = () => {
    const onClose = () => {
      setShowAddNewWhale(false);
      setValidNewWhale(false);
    };
    return (
      <>
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <ConfirmAlert title="New Whale Reminder" onClose={onClose}>
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Enter contract address..."
                    onChange={e => handleOnChangeAddNewWhale(e)}
                  />
                </div>
                <div className="search-input">
                  <input type="text" placeholder="Target ratio" />
                </div>
                <div className="search-input">
                  <select>
                    <option>Ratio down below</option>
                    <option>Ratio high above</option>
                  </select>
                </div>
                {showAddNewWhaleError && (
                  <div className="alert">
                    <img src="/icons/warning-solid.svg" />
                    {showAddNewWhaleError}
                  </div>
                )}
                <div className="confirm-button-container">
                  <Button color="one" size="large" label="Cancel" onClick={onClose} />
                  <Button
                    color="three"
                    size="large"
                    disabled={!validNewWhale}
                    onClick={() => {
                      addToReminderWhale(newWhale);
                    }}
                    label="Add to Reminders"
                  />
                </div>
              </ConfirmAlert>
            </div>
          </div>
        </div>
      </>
    );
  };

  // use effect
  useEffect(() => {
    setShowAddNewEnsError('');
  }, [newEns]);

  useEffect(() => {
    const initialEnsTableData: RemindersEnsTableDataProps[] = new Array();
    const initialTokenTableData: RemindersTokenTableDataProps[] = new Array();
    const initialWhaleTableData: RemindersWhaleTableDataProps[] = new Array();

    if (config) {
      if (selectedType === 'ens') setTableDataEns(initialEnsTableData);
      else if (selectedType === 'token') setTableDataToken(initialTokenTableData);
      else if (selectedType === 'whale') setTableDataWhale(initialWhaleTableData);

      fetchRemindersList();
    } else {
      setTableDataEns(initialEnsTableData);
      setTableDataToken(initialTokenTableData);
      setTableDataWhale(initialWhaleTableData);
    }
  }, [config, selectedType]);

  useEffect(() => {
    renderShowTable(tableDataEns);
    if (isMobile && document.getElementsByClassName('rdt_Table')[0]) {
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 50,
          behavior: 'smooth',
        });
      }, 200);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 60,
          behavior: 'smooth',
        });
      }, 210);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 70,
          behavior: 'smooth',
        });
      }, 220);

      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 0,
          behavior: 'smooth',
        });
      }, 800);
    }
  }, [tableDataEns]);

  useEffect(() => {
    renderShowTable(tableDataToken);
    if (isMobile && document.getElementsByClassName('rdt_Table')[0]) {
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 50,
          behavior: 'smooth',
        });
      }, 200);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 60,
          behavior: 'smooth',
        });
      }, 210);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 70,
          behavior: 'smooth',
        });
      }, 220);

      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 0,
          behavior: 'smooth',
        });
      }, 800);
    }
  }, [tableDataToken]);

  useEffect(() => {
    renderShowTable(tableDataWhale);
    if (isMobile && document.getElementsByClassName('rdt_Table')[0]) {
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 50,
          behavior: 'smooth',
        });
      }, 200);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 60,
          behavior: 'smooth',
        });
      }, 210);
      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 70,
          behavior: 'smooth',
        });
      }, 220);

      setTimeout(() => {
        document.getElementsByClassName('rdt_Table')[0].scroll({
          left: 0,
          behavior: 'smooth',
        });
      }, 800);
    }
  }, [tableDataWhale]);

  useEffect(() => {
    const tmpDataEns: RemindersEnsTableDataProps[] = new Array();
    const tmpDataToken: RemindersTokenTableDataProps[] = new Array();
    const tmpDataWhale: RemindersWhaleTableDataProps[] = new Array();
    if (selectedType === 'ens' && rawData && rawData.ENS) {
      Object.values(rawData!.ENS).forEach((item: any) => {
        tmpDataEns.push({
          id: Number(item.id),
          expiry_date: item.expiry_date,
          domain: item.domain,
          button: true,
        });
      });
      setTableDataEns(tmpDataEns);
    } else if (selectedType === 'token' && rawData && rawData.Portfolio) {
      Object.values(rawData!.Portfolio).forEach((item: any) => {
        tmpDataToken.push({
          id: Number(item.id),
          direction: item.direction,
          price: item.price,
          token: item.token,
          finalPrice: item.finalPrice,
          kind: item.kind,
          button: true,
        });
      });
      setTableDataToken(tmpDataToken);
    } else if (selectedType === 'whale' && rawData && rawData.Whales) {
      Object.values(rawData!.Whales).forEach((item: any) => {
        console.log(item);
        tmpDataWhale.push({
          id: Number(item.id),
          direction: item.direction,
          price: item.price,
          token: item.token,
          contract: item.contract,
          ratio: `${parseFloat(parseFloat(item.ratio).toFixed(2).toString())}%`,
          quantity: parseFloat(item.quantity)
            .toFixed(2)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
          button: true,
        });
      });
      setTableDataWhale(tmpDataWhale);
    }
  }, [rawData]);

  return (
    <div className="reminders">
      <BigMenu horizontal={true} />
      <div className="button-container mt-5 mb-5">
        <div onClick={() => setSelectedType('ens')}>
          <BigButton
            size="small"
            name="Ens"
            type={`${selectedType === 'ens' ? 'light' : 'dark'}`}
          />
        </div>
        <div onClick={() => setSelectedType('token')}>
          <BigButton
            size="small"
            name="Token"
            type={`${selectedType === 'token' ? 'light' : 'dark'}`}
          />
        </div>
        <div onClick={() => setSelectedType('whale')}>
          <BigButton
            size="small"
            name="Whale"
            type={`${selectedType === 'whale' ? 'light' : 'dark'}`}
          />
        </div>
      </div>
      {selectedType === 'ens' && config && (
        <div className={`custom-table-${theme} mt-5 padding-left`}>
          <div className="table-border-top" />
          <div>{showTable}</div>
          <div className="table-border-bottom" />
        </div>
      )}
      {selectedType === 'token' && config && (
        <div className={`custom-table-${theme} mt-5 padding-left`}>
          <div className="table-border-top" />
          <div>{showTable}</div>
          <div className="table-border-bottom" />
        </div>
      )}
      {selectedType === 'whale' && config && (
        <div className={`custom-table-${theme} mt-5 padding-left`}>
          <div className="table-border-top" />
          <div>{showTable}</div>
          <div className="table-border-bottom" />
        </div>
      )}

      {selectedType === 'ens' &&
        rawData &&
        rawData.ENS &&
        Object.values(rawData.ENS) &&
        Object.values(rawData.ENS).length > 0 && (
          <div className="mt-5">
            <div className="light-button-container">
              <div className="light-button">
                <Button
                  onClick={() => setShowAddNewEns(!showAddNewEns)}
                  color="one"
                  size="large"
                  label="New Ens Reminder"
                />
              </div>
            </div>
          </div>
        )}

      {selectedType === 'token' &&
        rawData &&
        rawData.ENS &&
        Object.values(rawData.ENS) &&
        Object.values(rawData.ENS).length > 0 && (
          <div className="mt-5">
            <div className="light-button-container">
              <div className="light-button">
                <Button
                  onClick={() => setShowAddNewToken(!showAddNewToken)}
                  color="one"
                  size="large"
                  label="New Token Reminder"
                />
              </div>
            </div>
          </div>
        )}

      {selectedType === 'whale' &&
        rawData &&
        rawData.ENS &&
        Object.values(rawData.ENS) &&
        Object.values(rawData.ENS).length > 0 && (
          <div className="mt-5">
            <div className="light-button-container">
              <div className="light-button">
                <Button
                  onClick={() => setShowAddNewWhale(!showAddNewWhale)}
                  color="one"
                  size="large"
                  label="New Whale Reminder"
                />
              </div>
            </div>
          </div>
        )}
      {showAddNewEns && addNewEns()}
      {showAddNewToken && addNewToken()}
      {showAddNewWhale && addNewWhale()}
    </div>
  );
};
